import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import { api } from "../lib/api";
import { useApp } from "../contexts/AppContext";

export default function ArtistsPage() {
  const [artists, setArtists] = useState([]);
  const [query, setQuery] = useState("");
  const { t, tp, lang } = useApp();

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data));
  }, []);

  // Lokalizasiya olunmuş axtarış placeholder-i
  const searchPlaceholder =
    lang === "ru" ? "Поиск исполнителя..." :
    lang === "en" ? "Search artist..." :
    "Sənətçi axtar...";

  // Axtarış filtri — ada və slug üzrə axtarır.
  const filteredArtists = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return artists;
    return artists.filter((a) => {
      const name = (a.name || "").toLowerCase();
      const slug = (a.slug || "").toLowerCase();
      return name.includes(q) || slug.includes(q);
    });
  }, [artists, query]);

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="artists-page">
      <h1 className="section-title text-5xl md:text-7xl mb-8">{tp("artists", "title", t.nav.artists)}</h1>

      {/* Axtarış bölməsi */}
      <div className="mb-10 max-w-xl">
        <div className="relative">
          <Search
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-muted)] pointer-events-none"
          />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
            className="w-full pl-10 pr-10 py-3 bg-transparent border border-[var(--border)] focus:border-[var(--text)] outline-none text-[var(--text)] placeholder:text-[var(--text-muted)] transition-colors"
            data-testid="artists-search-input"
          />
          {query && (
            <button
              type="button"
              onClick={() => setQuery("")}
              aria-label="Clear"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text-muted)] hover:text-[var(--text)] transition-colors"
              data-testid="artists-search-clear"
            >
              <X size={18} />
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-6 md:gap-8">
        {filteredArtists.map((a) => (
          <Link key={a.id} to={`/artist/${a.id}`} className="group block" data-testid={`artist-card-${a.slug || a.id}`}>
            <div className="aspect-[3/4] card-flat zoom-wrap relative">
              <img src={a.image_url} alt={a.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition" />
            </div>
            <div className="mt-2 sm:mt-4 flex items-center justify-between gap-1 sm:gap-2">
              <h3 className="font-display text-sm sm:text-xl md:text-2xl truncate">{a.name}</h3>
              {a.featured && <span className="metadata text-[var(--accent)] shrink-0 hidden sm:inline">{t.artists.featuredBadge}</span>}
            </div>
          </Link>
        ))}
      </div>

      {/* Boş nəticə vəziyyəti */}
      {filteredArtists.length === 0 && (
        <div className="text-center py-16 text-[var(--text-muted)]" data-testid="artists-empty">
          {lang === "ru" ? "Ничего не найдено" :
           lang === "en" ? "No artists found" :
           "Heç bir sənətçi tapılmadı"}
        </div>
      )}
    </div>
  );
}
